import React, { useEffect, useState } from 'react'
import styles from './ClaimsPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import Select from 'react-select'
import iconFiltersMobile from '../../assets/icons/iconFiltersMobile.svg'
import plusIcon from '../../assets/icons/plus.svg'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useNavigate } from 'react-router-dom'
import { claimStatusesFromBack, requestsPerPage } from '../../constants/constants'

import glassIcon from '../../assets/icons/glass.svg'

import {
  getAllClaims,
  getAllClaimsFromPlatforms,
  getPagedClaims,
} from '../../redux/actions/claimsAction'

import PATH from '../../navigation/path'

import CustomModal from '../../components/UI/CustomModal/CustomModal'
import CreateClaim from '../../components/CreateClaim/CreateClaim'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import { useMediaQuery } from 'react-responsive'
import { useRequestStatus } from '../../hooks/useRequestStatus'
import { useDebounce } from '../../hooks/useDebounce'
import { ClaimResponseType } from '../../redux/actions/types'
import { getOrders } from '../../redux/actions/ordersAction'
import { getRegistrationRequests } from '../../redux/actions/registartionRequestAction'
import { getCompanies } from '../../redux/actions/companiesAction'
import FilterModal from '../../components/FilterModal/FilterModal'
import { getClients } from '../../redux/actions/clientsAction'
import { getPlaces } from '../../redux/actions/placesAction'
import { authLogout } from '../../redux/reducers/auth/authSlice'

const ClaimsPage = () => {
  const { token, user, userRole } = useAppSelector((state) => state.auth)

  const { clients } = useAppSelector((state) => state.clients)
  useEffect(() => {
    dispatch(getClients({ token }) as any)
  }, [])

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [createClaimModal, setCreateClaimModal] = useState(false)
  const [filterModal, setFilterModal] = useState(false)

  const [search, setSearch] = useState<string>('')

  const [filteredClaims, setFilteredClaims] = useState<ClaimResponseType[]>([])
  const [statusFilter, setStatusFilter] = useState<'Все' | 'inProgress' | 'accepted'>('Все')
  const [placeFilter, setPlaceFilter] = useState<string>('')
  const [userFilter, setUserFilter] = useState<string>('')
  const [requestStatus, setRequestStatus] = useState<any>('')
  const [currentPage, setCurrentPage] = useState(1)
  const debouncedStatus = useRequestStatus(requestStatus)
  const debounced = useDebounce(search, 1000)
  const companyId = user?.employee?.company?.id
  const itemsToLoad = 1000

  const formatDateRange = (startDate: string, endDate: string): string => {
    try {
      const formatDate = (date: string): string => {
        const year = date.slice(0, 4)
        const month = date.slice(5, 7)
        const day = date.slice(8, 10)
        const hours = date.slice(11, 13)
        const minutes = date.slice(14, 16)

        return `${day}.${month}.${year}, ${hours}:${minutes}`
      }

      return `${formatDate(startDate)} - ${formatDate(endDate)}`
    } catch (error) {
      console.error('Ошибка форматирования даты:', error)
      return `${startDate} - ${endDate}`
    }
  }

  const { allClaimsFromPlaces, pagedClaims, allClaims } = useAppSelector((state) => state.claims)
  const { registrationRequests } = useAppSelector((state) => state.registrationRequest)

  const { companies } = useAppSelector((state) => state.companies)

  useEffect(() => {
    if (!token) {
      return
    }

    const fetchPlaces = async () => {
      const resultAction = await dispatch(
        getPlaces({
          token,
          page: 1,
          itemsPerPage: 100,
        }),
      )

      if (getPlaces.rejected.match(resultAction)) {
        const errorMessage = resultAction.payload
        if (errorMessage === 'Unauthorized') {
          dispatch(authLogout())
          navigate(PATH.authPage)
          window.location.reload()
        }
      }
    }

    fetchPlaces()
  }, [dispatch, token])

  const totalPages = Math.ceil(Number(pagedClaims[1]) / itemsToLoad)

  const generatePageNumbers = () => {
    const pages: (number | string)[] = []

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, '...', totalPages)
      } else if (currentPage >= totalPages - 3) {
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages)
      } else {
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages)
      }
    }

    return pages
  }
  const pagesNumbers = generatePageNumbers()

  useEffect(() => {
    setCurrentPage(1)
  }, [debounced])

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1)
    }
  }
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber)
  }

  const onNavigateToCurrentClaim = (id: number) => {
    navigate(`${PATH.claimCardPage}${id}`)
  }

  useEffect(() => {
    dispatch(
      getPagedClaims({
        token,
        page: currentPage,
        limit: itemsToLoad,
        search: debounced.trim() || undefined,
      }),
    )
    dispatch(
      getCompanies({
        token: token,
        page: 1,
        itemsPerPage: 100,
      }),
    )
  }, [dispatch, token, currentPage, debounced])

  useEffect(() => {
    if (pagedClaims && Array.isArray(pagedClaims[0])) {
      filterClaims(pagedClaims[0])
    }
  }, [pagedClaims, statusFilter, placeFilter, userFilter])

  const filterClaims = (claims: ClaimResponseType[]) => {
    let filtered = claims

    if (statusFilter !== 'Все') {
      filtered = filtered.filter((claim) => claim.status === statusFilter)
    }

    if (placeFilter) {
      filtered = filtered.filter((claim) =>
        claim.place.name.toLowerCase().includes(placeFilter.toLowerCase()),
      )
    }

    if (userFilter) {
      filtered = filtered.filter((claim) =>
        claim?.place?.company?.name?.toLowerCase().includes(userFilter.toLowerCase()),
      )
    }

    setFilteredClaims(filtered)
  }

  const getClaimStatus = (statusKey: any): any => {
    if (!claimStatusesFromBack || typeof claimStatusesFromBack !== 'object') {
      console.warn('claimStatusesFromBack is not available or invalid!')
      return statusKey
    }
    return claimStatusesFromBack[statusKey]
  }

  const filteredRequests = allClaimsFromPlaces
    .flatMap((item) => item.requests)
    .filter((request) => {
      let isValid = request?.user?.id == user?.id

      if (statusFilter !== 'Все' && request?.status !== statusFilter) {
        isValid = false
      }

      if (placeFilter && !request?.name?.toLowerCase().includes(placeFilter.toLowerCase())) {
        isValid = false
      }

      if (
        userFilter &&
        !request?.user?.fullName.toLowerCase().includes(userFilter?.toLowerCase())
      ) {
        isValid = false
      }

      return isValid
    })

  useEffect(() => {
    dispatch(getOrders({ token }))
    dispatch(getPagedClaims({ token, page: 1, limit: itemsToLoad }))

    dispatch(getAllClaims({ token }))
    dispatch(
      getRegistrationRequests({
        requestStatus: debouncedStatus,
        search: debounced,
        page: 1,
        itemsPerPage: requestsPerPage,
      }),
    )
    if (userRole !== 'superAdmin') {
      dispatch(getAllClaimsFromPlatforms({ token, companyId: String(companyId) }))
    }
  }, [dispatch, token])

  const handleStatusChange = (status: 'Все' | 'inProgress' | 'accepted') => {
    setStatusFilter(status)
  }

  const handlePlaceFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPlaceFilter(e.target.value)
  }

  const handleUserFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setUserFilter(e.target.value)
  }

  const placeNames = allClaims.reduce((acc, claim) => {
    if (!acc.includes(claim.place.name)) {
      acc.push(claim.place.name)
    }
    return acc
  }, [] as string[])

  const claimsUserNames = allClaims.reduce((acc, claim) => {
    if (claim?.user && claim.user?.fullName && !acc.includes(claim?.user?.fullName)) {
      acc.push(claim?.user?.fullName)
    }
    return acc
  }, [] as string[])

  const registrationUserNames = registrationRequests?.requests.reduce(
    (acc: string[], request: any) => {
      if (request?.contactFullName && !acc.includes(request?.contactFullName)) {
        acc.push(request?.contactFullName)
      }
      return acc
    },
    [],
  )

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  return (
    <div className={styles.claimsPageContainer}>
      <Navbar />
      <div className={styles.claimsPage}>
        <CustomModal visible={createClaimModal} setVisible={setCreateClaimModal}>
          <CreateClaim
            client={clients}
            onClickHandler={() => setCreateClaimModal(false)}
            customer={user.fullName}
          />
        </CustomModal>
        <CustomModal visible={filterModal} setVisible={setFilterModal}>
          <FilterModal
            setUserFilter={setUserFilter}
            setPlaceFilter={setPlaceFilter}
            companies={companies.companies}
            placeNames={placeNames}
            onClickHandler={() => setFilterModal(false)}
          />
        </CustomModal>
        <div className={styles.titleMainBlock}>
          <div className={styles.titleBlock}>Заявки</div>
        </div>

        <div className={styles.statusFilter}>
          <div className={styles.filtersLeft}>
            {!isMobile && (
              <>
                <button
                  onClick={() => handleStatusChange('Все')}
                  className={statusFilter === 'Все' ? styles.active : ''}
                >
                  Все
                </button>
                <button
                  onClick={() => handleStatusChange('inProgress')}
                  className={statusFilter === 'inProgress' ? styles.active : ''}
                >
                  В процессе
                </button>
                <button
                  onClick={() => handleStatusChange('accepted')}
                  className={statusFilter === 'accepted' ? styles.active : ''}
                >
                  Завершенные
                </button>
              </>
            )}
            {isMobile && (
              <>
                <div className={styles.filterMobileContainer}>
                  <button
                    onClick={() => handleStatusChange('Все')}
                    className={statusFilter === 'Все' ? styles.active : ''}
                  >
                    Все
                  </button>
                  <button
                    onClick={() => handleStatusChange('inProgress')}
                    className={statusFilter === 'inProgress' ? styles.active : ''}
                  >
                    В процессе
                  </button>
                  <button
                    onClick={() => handleStatusChange('accepted')}
                    className={statusFilter === 'accepted' ? styles.active : ''}
                  >
                    Завершенные
                  </button>
                </div>
                <CustomButton
                  iconSrc={iconFiltersMobile}
                  className={styles.filtersBtn}
                  type='button'
                  onClick={() => setFilterModal(true)}
                />
              </>
            )}
          </div>
          <div className={styles.filtersRight}>
            {userRole === 'superAdmin' && !isMobile && (
              <div className={styles.modalFilters}>
                <div className={styles.selectInputBlock}>
                  <Select
                    options={[
                      { value: '', label: 'Все места' },
                      ...placeNames.map((name) => ({ value: name, label: name })),
                    ]}
                    value={placeFilter ? { value: placeFilter, label: placeFilter } : null}
                    onChange={(selectedOption) => {
                      handlePlaceFilterChange({
                        target: { value: selectedOption?.value || '' },
                      } as React.ChangeEvent<HTMLSelectElement>)
                    }}
                    className={styles.selectInput}
                    classNamePrefix='react-select'
                    isClearable={false}
                    placeholder='Зал'
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        border: 'none',
                        boxShadow: 'none',
                        minHeight: 'auto',
                        backgroundColor: 'transparent',
                      }),
                      menu: (provided) => ({
                        ...provided,
                        right: 0,
                        width: 'max-content',
                        overflow: 'auto',
                        height: 'auto',
                      }),
                      input: (provided) => ({
                        ...provided,
                        margin: 0,
                        padding: 0,
                      }),
                      valueContainer: (provided) => ({
                        ...provided,
                        padding: 0,
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,

                        padding: 0,
                      }),
                      indicatorSeparator: () => ({
                        display: 'none',
                      }),
                    }}
                  />
                </div>
                <div className={styles.selectInputBlock}>
                  <Select
                    options={[
                      { value: '', label: 'Все компании' },
                      ...companies.companies.map((company) => ({
                        value: company.name,
                        label: company.name,
                      })),
                    ]}
                    value={userFilter ? { value: userFilter, label: userFilter } : null}
                    onChange={(selectedOption) => {
                      handleUserFilterChange({
                        target: { value: selectedOption?.value || '' },
                      } as React.ChangeEvent<HTMLSelectElement>)
                    }}
                    className={styles.selectInput}
                    classNamePrefix='react-select'
                    isClearable={false}
                    placeholder='Компании'
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        border: 'none',
                        boxShadow: 'none',
                        minHeight: 'auto',
                        backgroundColor: 'transparent',
                      }),
                      menu: (provided) => ({
                        ...provided,
                        width: 'max-content',
                        right: 0,
                        overflow: 'auto',
                        height: 'auto',
                      }),
                      input: (provided) => ({
                        ...provided,
                        margin: 0,
                        padding: 0,
                      }),
                      valueContainer: (provided) => ({
                        ...provided,
                        padding: 0,
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: 0,
                      }),
                      indicatorSeparator: () => ({
                        display: 'none',
                      }),
                    }}
                  />
                </div>
              </div>
            )}
            <div className={styles.searchInputContainer}>
              <img src={glassIcon} alt='' />
              <div className={styles.searchInput}>
                <input
                  type='text'
                  placeholder='Поиск по имени менеджера'
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className={styles.searchInput}
                />
              </div>
            </div>
            <CustomButton
              iconSrc={isMobile ? plusIcon : ''}
              className={styles.addSiteBtn}
              title={isMobile ? '' : 'Создать заявку'}
              type='button'
              onClick={() => setCreateClaimModal(true)}
            />
          </div>
        </div>

        <table className={styles.tableContainer}>
          <thead className={styles.tableHeader}>
            <tr className={styles.tableHeaderRow}>
              <th className={styles.headerItem}>Зал</th>
              <th className={styles.headerItem}>Город</th>
              <th className={styles.headerItem}>Менеджер</th>
              <th className={styles.headerItem}>Дата</th>
              <th className={styles.headerItem}>Кол-во гостей</th>
              <th className={styles.headerItem}>Статус</th>
            </tr>
          </thead>
          <tbody className={styles.tableBody}>
            {filteredClaims.map((claim) => (
              <tr
                onClick={() => onNavigateToCurrentClaim(claim.id)}
                className={styles.tableBodyRow}
                key={claim.id}
              >
                <td className={styles.bodyItem}>{claim.place.name}</td>
                <td className={styles.bodyItem}>{claim?.place.city}</td>
                <td className={styles.bodyItem}>
                  {claim?.manager?.fullName || claim?.user?.fullName}
                </td>
                <td className={styles.bodyItem}>
                  {formatDateRange(claim?.startDate, claim?.endDate)}
                </td>
                <td className={styles.bodyItem}>{claim?.peopleCount} чел.</td>
                <td className={styles.bodyItem}>{getClaimStatus(claim.status)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ClaimsPage
